import AddAttribution from './add-attribution';

export default AddAttribution;
